import { render, staticRenderFns } from "./DropdownContainer.vue?vue&type=template&id=b88581d8&scoped=true&"
import script from "./DropdownContainer.vue?vue&type=script&lang=ts&"
export * from "./DropdownContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownContainer.vue?vue&type=style&index=0&id=b88581d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88581d8",
  null
  
)

export default component.exports